import { FETCH_PROFESSION_REQUEST } from "./constants";
import { combineReducers } from "redux";
import { Action } from "./types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Profession } from "../types";

function item(state: Partial<Profession> = {}, action: Action): Partial<Profession> {
  switch (action.type) {
    case getSuccessActionType(FETCH_PROFESSION_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_PROFESSION_REQUEST:
      return true;

    case getSuccessActionType(FETCH_PROFESSION_REQUEST):
    case getFailureActionType(FETCH_PROFESSION_REQUEST):
      return false;

    default:
      return state;
  }
}

export const profession = combineReducers({ item, isFetching });
